'use client';

import { useEffect } from 'react';
import { useCartCheckoutStore } from 'stores/cart';
import { useReloadOnPageRestore } from '../../hooks/checkout';

/**
 * The consent must be given per visit of the step, so a tick from an earlier visit must not survive.
 * A page restored from the bfcache is a new visit too, so it reloads. Renders nothing.
 */
export function ResetCheckoutState() {
  const reset = useCartCheckoutStore(store => store.reset);

  useReloadOnPageRestore();

  useEffect(() => {
    reset();
  }, [reset]);

  return null;
}
